export const requestFullscreen = (element) => {
    if (element.requestFullscreen) {
        element.requestFullscreen();
    }
    else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
    }
    else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    }
    else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
    }
};
export const requestFullscreenMobileIOS = (element) => {
    if (element.webkitEnterFullScreen) {
        element.webkitEnterFullScreen();
    }
};
export const exitFullscreen = () => {
    if (typeof document === "undefined")
        return;
    if (document.exitFullscreen) {
        document.exitFullscreen();
    }
    else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    }
    else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    }
    else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    }
};
export const fullscreenEnabled = () => {
    const doc = document;
    return (doc.fullscreenEnabled || doc.webkitFullscreenEnabled || doc.mozFullScreenEnabled || doc.msFullscreenEnabled || false);
};
export const isFullscreen = () => {
    if (typeof document === "undefined")
        return false;
    const doc = document;
    return (!!doc.fullscreenElement || !!doc.webkitFullscreenElement || !!doc.mozFullScreenElement || !!doc.msFullscreenElement);
};
//# sourceMappingURL=fullscreenHelpers.js.map